import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LogoUpload from './LogoUpload';

class LogoUploadContainer extends PureComponent {
  onFileSelect = (e) => {
    e.preventDefault();
    const { input, acceptedTypes, maxSize } = this.props;
    const file = e.target.files[0];
    const reader = new window.FileReader();

    reader.onloadend = () => {
      input.onChange(reader.result);
    };
    if (file && (!maxSize || file.length <= maxSize) && acceptedTypes.includes(file.type)) {
      e.target.value = null;
      reader.readAsDataURL(file);
    }
  };

  onFileRemove = () => {
    const { input } = this.props;
    input.onChange('');
  };

  render() {
    const { input: { value, name }, acceptedTypes } = this.props;
    return (
      <LogoUpload
        name={name}
        logoSrc={value}
        onFileSelect={this.onFileSelect}
        onFileRemove={this.onFileRemove}
        acceptedTypes={acceptedTypes}
      />
    );
  }
}

LogoUploadContainer.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  acceptedTypes: PropTypes.arrayOf(PropTypes.string),
  maxSize: PropTypes.number,
};

LogoUploadContainer.defaultProps = {
  acceptedTypes: [],
  maxSize: null,
};

export default LogoUploadContainer;
